/**
 * Drip API Functionality
 * ----------------------
 * 
 * @type {Object}
 */
SITE.Drip = {
        
    /**
     * If the Drip object _dcq is not 
     * loaded we will retry X number 
     * of times. This var keeps track.
     * 
     * @type {Number}
     */
    apiTries: 0,
    loaded: false,
    subscribed: false,
    
    User: {
        email: "",
        fields: {},
        tags: [],
        score: 0
    },

    /**
     * Initialization:
     * Run on Load
     */
    init: function() {
        "use strict";

        SITE.Drip.ifLoaded(function() {
            
            SITE.Drip.identifyUser();
            SITE.Drip.checkUrlParam()
            SITE.Drip.initTaggingLinks();
            SITE.Drip.bodyTagging();
            SITE.Drip.contentUpgradeTagging();

        });

    },

    identifyUser: function() {
        "use strict";

        SITE.Drip.identify({

            success: function(response) {
                
                SITE.Tracking.Conversions.setDripID(response.visitor_uuid);

                // Set for later access
                SITE.Drip.User.email     = response.email;
                SITE.Drip.User.fields    = response.custom_fields;
                SITE.Drip.User.tags      = response.tags;
                SITE.Drip.User.score     = response.lead_score;

                if (response.anonymous === false ) {
                    SITE.Drip.subscribed = true;
                    SITE.Marketing.disable();
                    SITE.Tracking.Conversions.setEmail(response.email);
                } else {
                    SITE.Marketing.enable();
                    SITE.Tracking.Conversions.trackShow();
                }
                //console.log(response);
            },

            failure: function() {
                //console.log("Something went wrong while identifying Drip User....");
            }

        });

    },

    /**
     * Check if email is set via a 
     * URL parameter names "e". 
     * 
     * This is used for Thank-You pages 
     * where the user is subscribed via 
     * the Drip API and so the Drip JS
     * on the site needs to be notified 
     * that the current user is a subscriber
     * already. 
     * 
     */
    checkUrlParam: function() {
        "use strict";
        
        var e = SITE.Drip.getEmailFromUrl();
        if (e !== false && e !== "") SITE.Drip.identify({ email: e });

    },

    /**
     * Return email address if set from 
     * URL parameter (e || drip_email)
     * @return {string || false} [description]
     */
    getEmailFromUrl: function() {
        "use strict";
        var e = SITE.Utils.getUrlParamByName("e");
        if (e === false) e = SITE.Utils.getUrlParamByName("drip_email");
        return e;
    },

    /**
     * Initialize Drip Tagging Links
     * 
     */
    initTaggingLinks: function() {
        "use strict";

        var e = SITE.Drip.getEmailFromUrl(), 
            tag, data;

        jQuery('[data-driptag]').click(function() {
            tag = jQuery(this).data('driptag');
            
            if (tag !== '') {
                
                data = { tags: [tag] };
                if (e !== false) data.email = e;
                
                SITE.Drip.identify(data);
                
                jQuery('[data-driphideaftertag]').slideUp(function() {
                    jQuery('[data-dripshowaftertag]').slideDown();
                });
            }
            return false;
        });

        
    },

    /**
     * Tag Users by Tags Provided in Body
     *
     */
    bodyTagging: function() {

        "use strict";

        SITE.Drip.trackTopInterest();

        var dripTags = $('body').data('drip-tags');

        if(dripTags) {

            // Default tagging functionality
            var e = SITE.Drip.getEmailFromUrl(), 
                data,
                email;

            email = (e !== false) ? e : SITE.Drip.User.email;

            data = { tags: [dripTags] };
            data.email = email;
                
            SITE.Drip.identify(data);

            // Remove all top interest tags first
            // IMPORTANT: these are now all hardcoded, in future we should probably make this dynamic
            var topInterest = SITE.Drip.getTopInterest();

            if(topInterest !== false) {

                var availableTags = [
                    'SEO Interest',
                    'PPC Interest',
                    'Retargeting Interest',
                    'Facebook Ads Interest',
                    'Video Ads Interest',
                    'Mobile Ads Interest',
                    'Content Marketing Interest',
                    'Infographics Interest',
                    'CRO Interest',
                    'Blog - SEO Interest',
                    'Blog - Link Building Interest',
                    'Blog - Conversions Interest',
                    'Blog - Content Marketing Interest',
                    'Blog - Blogging Interest',
                ];

                if(jQuery.inArray(topInterest, availableTags) !== -1) {

                    // Generate an array of tags to remove
                    var tagsToRemove = [];

                    $.each(availableTags, function(key, value) {
                        tagsToRemove[key] = 'Top Interest - ' + value;
                    });

                    // Remove these tags (must remove all)
                    data = { remove_tags: tagsToRemove };
                    data.email = email;
                        
                    SITE.Drip.identify(data);

                    // Add current top interest tag
                    data = { tags: ['Top Interest - ' + topInterest] };
                    data.email = email;
                        
                    SITE.Drip.identify(data);

                }

            }

        }

    },

    /**
     * Tag lead magnets of content upgrades.
     */
    contentUpgradeTagging: function() {
        "use strict";

        if($('.sg-content-upgrade').length > 0) {

            $('.sg-content-upgrade .sg-content-upgrade--cta').on('click', function() {

                var category = $(this).data('category'),
                    e = SITE.Drip.getEmailFromUrl(), 
                    data;

                if(category !== '') {

                    data = { tags: [ 'Lead Magnet - ' + category ] };
                    if (e !== false) data.email = e;

                    SITE.Drip.identify(data);

                }

            });

        }
    },

    /**
     * Track visitors top interest.
     */
    trackTopInterest: function() {
        "use strict";

        var dripTags = $('body').data('drip-tags');

        if(dripTags && dripTags.indexOf(' Interest') >= 0) {

            // Get current list of top interests
            var topInterests = Cookies.get('sg-top-interests');

            if(typeof topInterests == 'undefined') {
                topInterests = {};
            } else {
                topInterests = Cookies.getJSON('sg-top-interests');
            }

            // Add to the list if not yet there
            if(typeof topInterests[dripTags] == 'undefined') {
                topInterests[dripTags] = 1;
            } else {
                topInterests[dripTags] = (topInterests[dripTags] + 1);
            }

            // Update data in the cookie
            Cookies.set('sg-top-interests', topInterests, { expires: 365 });

        }
    },

    /**
     * Get visitor's top interest.
     */
    getTopInterest: function() {
        "use strict";

        var topInterests = Cookies.getJSON('sg-top-interests');

        if(typeof topInterests != 'undefined') {

            var lastScore = 0,
                topInterest = false;

            $.each(topInterests, function(key, value) {
                if(value >= lastScore) {
                    lastScore = parseInt(value);
                    topInterest = key;
                }
            });

            return topInterest;

        }

        return false;
    },

    ifLoaded: function(callback) {
        "use strict";

        if (typeof _dcq === "undefined") {

            SITE.Drip.apiTries += 1;

            if (SITE.Drip.apiTries < 10) {
                window.setTimeout(function() {
                    SITE.Drip.ifLoaded(callback);
                }, 600);

            }
        } else {

            SITE.Drip.loaded = true;
            callback();
        }
    },

    /**
     * Push data to Drip via API
     * More info at: https://www.getdrip.com/docs/js-api
     * 
     * @param  {Object} data JS Object to push
     * @return {Object}      Response from Drip
     */
    identify: function(data) {
        "use strict";

        SITE.Drip.ifLoaded( function() {
            return _dcq.push(["identify", data]);
        });
    },

    /**
     * Default Drip Push
     * More info at: https://www.getdrip.com/docs/js-api
     * 
     * @param  {String} method Drip API Method
     * @param  {Object} data   Drip
     * @return {[type]}        [description]
     */
    push: function(method, data) {
        "use strict";

        SITE.Drip.ifLoaded( function() {
            return _dcq.push([method, data]);
        });
    }
};